import { c as _c } from "react/compiler-runtime";
import { SvgIcon, SvgIconProps } from '@mui/material';
const CCNDIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M7.818 0.144c-4.253 0.108-7.675 3.596-7.675 7.875 0 4.347 3.528 7.875 7.875 7.875s7.875-3.528 7.875-7.875c0-4.347-3.528-7.875-7.875-7.875-0.068 0-0.132-0.002-0.2 0zM7.81 1.497c0.070-0.002 0.137 0 0.208 0 3.6 0 6.521 2.922 6.521 6.521s-2.922 6.521-6.521 6.521-6.521-2.922-6.521-6.521c0-3.529 2.811-6.41 6.314-6.521zM5.258 6.156h5.799v1.422h-5.799v-1.422zM5.258 8.727h5.799v1.422h-5.799v-1.422z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SvgIcon viewBox="0 0 16 16" {...props}>{t0}</SvgIcon>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default CCNDIcon;